import "./chunk-7B52C2XE.js";
const PARA_CORE_VERSION = "1.18.1";
const PREFIX = "@CAPSULE/";
const LOCAL_STORAGE_EMAIL = `${PREFIX}e-mail`;
const LOCAL_STORAGE_PHONE = `${PREFIX}phone`;
const LOCAL_STORAGE_COUNTRY_CODE = `${PREFIX}countryCode`;
const LOCAL_STORAGE_FARCASTER_USERNAME = `${PREFIX}farcasterUsername`;
const LOCAL_STORAGE_TELEGRAM_USER_ID = `${PREFIX}telegramUserId`;
const LOCAL_STORAGE_EXTERNAL_WALLET_USER_ID = `${PREFIX}externalWalletUserId`;
const LOCAL_STORAGE_USER_ID = `${PREFIX}userId`;
const LOCAL_STORAGE_ED25519_WALLETS = `${PREFIX}ed25519Wallets`;
const LOCAL_STORAGE_WALLETS = `${PREFIX}wallets`;
const LOCAL_STORAGE_EXTERNAL_WALLETS = `${PREFIX}externalWallets`;
const LOCAL_STORAGE_CURRENT_WALLET_IDS = `${PREFIX}currentWalletIds`;
const LOCAL_STORAGE_SESSION_COOKIE = `${PREFIX}sessionCookie`;
const SESSION_STORAGE_LOGIN_ENCRYPTION_KEY_PAIR = `${PREFIX}loginEncryptionKeyPair`;
const POLLING_INTERVAL_MS = 2e3;
const SHORT_POLLING_INTERVAL_MS = 1e3;
const EXTERNAL_WALLET_CONNECTION_ONLY_USER_ID = "EXTERNAL_WALLET_CONNECTION_ONLY";
export {
  EXTERNAL_WALLET_CONNECTION_ONLY_USER_ID,
  LOCAL_STORAGE_COUNTRY_CODE,
  LOCAL_STORAGE_CURRENT_WALLET_IDS,
  LOCAL_STORAGE_ED25519_WALLETS,
  LOCAL_STORAGE_EMAIL,
  LOCAL_STORAGE_EXTERNAL_WALLETS,
  LOCAL_STORAGE_EXTERNAL_WALLET_USER_ID,
  LOCAL_STORAGE_FARCASTER_USERNAME,
  LOCAL_STORAGE_PHONE,
  LOCAL_STORAGE_SESSION_COOKIE,
  LOCAL_STORAGE_TELEGRAM_USER_ID,
  LOCAL_STORAGE_USER_ID,
  LOCAL_STORAGE_WALLETS,
  PARA_CORE_VERSION,
  POLLING_INTERVAL_MS,
  PREFIX,
  SESSION_STORAGE_LOGIN_ENCRYPTION_KEY_PAIR,
  SHORT_POLLING_INTERVAL_MS
};
